import { createRequest, RequestConfig } from 'app/common/api';

import { TNewRole } from '../core/role';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_role',
};

export const addRoleRequest = (body: TNewRole) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
